$.fn.navSelect = function () {
  return this.each(function () {
    var $self = $(this);
    var plugin = $.fn.navSelect;

    // If is the control;ing element...
    if ($self.is('[id="dataSource"]')) {
      var $form = $self.closest("form");
      var isValidForm = $form.data("nvslct-id") === $self.data("nvslct-target");

      // Save the value of the 'controlling' element for the
      // 'controlled' elements to use...
      plugin.config.setNavSelectValue($self.val());

      // Event binding for handling change
      $self.on("change", function () {
        // Update config
        plugin.config.setNavSelectValue($self.val());

        // Trigger dependents
        plugin.config.getControlledElements().trigger("dclg.nvslct.changed");

        // Submit form, if appropriate
        if (isValidForm) {
          $form.submit();
        }

        console.log("$self", {
          myValue: $self.val(),
          myDependents: plugin.config.getControlledElements(),
          ValidFormPresent: isValidForm,
        });
      });
    } else {
      // Event binding for when the controlling element changes..
      $self.on("dclg.nvslct.changed", function () {
        $self.val(plugin.config.getNavSelectValue());
      });

      // Init with value of the controlling element
      $self.val(plugin.config.getNavSelectValue());
    }
  });
};

$.fn.navSelect.config = {
  _navSelectValue: "",
  setNavSelectValue: function (v) {
    this._navSelectValue = v;
  },
  getNavSelectValue: function () {
    return this._navSelectValue;
  },
  getControlledElements: function () {
    return $(".nav-select").filter(function () {
      return !$(this).is('[id="dataSource"]');
    });
  },
};
